import React from 'react';
import styled from 'styled-components';
import Placeholder from '../../../assets/svg/profile-placeholder.svg';
import { convertToThumbnail300 } from '../../../utils/thumbnails';

interface Props {
  size: number;
  imageUrl?: string;
}

const Photo = styled.img<{ size: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: ${props => props.size}px;
`;

const BidderPhoto = ({ imageUrl, size }: Props) => {
  if (!!imageUrl) {
    return <Photo size={size} src={convertToThumbnail300(imageUrl)} />;
  } else {
    return <Photo size={size} src={Placeholder} />;
  }
};

export default BidderPhoto;
